<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="700px"
    custom-class="protocol-dialog"
    :title="title"
    @close="handleClose"
  >
    <div class="protocol-content" v-html="protocolContent"></div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleConfirm">{{ confirmText }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'ProtocolDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '协议'
    },
    confirmText: {
      type: String,
      default: '我已知晓'
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    },
    protocolContent () {
      return this.getProtocolContent()
    }
  },
  methods: {
    handleClose () {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    handleConfirm () {
      this.$emit('update:visible', false)
      this.$emit('confirm')
    },
    getProtocolContent () {
      return `
        <div class="protocol-text">
          <h3 style="text-align: center; margin-bottom: 20px; font-size: 18px; font-weight: bold;">赠礼服务协议</h3>

          <p style="margin-bottom: 10px;"><strong>甲方：</strong>南京万知园信息工程有限公司（以下简称"万知网"）</p>

          <p style="margin-bottom: 20px;"><strong>乙方：</strong>万知网站所有用户（以下简称"用户"）</p>

          <p style="margin-bottom: 20px;">在您使用万知平台打赏功能之前，请您充分阅读本协议，平台用户及万知网接受本协议约束。用户实际使用万知平台及或其活动服务，亦使得本协议生效。</p>

          <h4 style="margin: 20px 0 10px; font-size: 16px; font-weight: bold;">一、用户保证</h4>
          <p style="margin-bottom: 10px; text-indent: 2em;">1.用户同意并保证，在本协议有效期内，万知网有权于任何时间要求用户提交相关资质证明资料原件或其他资料信息，用户对其所提交信息的真实完整、合法有效性承担保证责任。</p>
          <p style="margin-bottom: 20px; text-indent: 2em;">2.用户同意并保证，用户合法并如约使用万知平台。用户对其资质及行为产生的任何法律责任，自行独立承担，与万知网无关。</p>

          <h4 style="margin: 20px 0 10px; font-size: 16px; font-weight: bold;">二、用户的权利和义务</h4>
          <p style="margin-bottom: 10px; text-indent: 2em;">1.用户知悉并同意：万知网打赏服务以献花的形式表现，如花朵 一分，小花 一角，鲜花一元，红花 二元，兰花三元，玫瑰五元，牡丹十元，荷花二十元，月季三十，幸运花五十元，开心花一百元，友谊花二百元，问好花三百元，祝福花五百元，心意花一千，真情花三千，礼花五千元，杜鹃花一万，宝莲花三万，金葵花五万等交互形式。万知平台设立这些消费旨在为广大用户提供万知网上的相关服务，或用户不以回报为目的的自愿打赏的行为，其打赏、服务的形式、内容万知网拥有全部解释权。(从即日起仅开通单次三千元及以下的送礼、打赏或服务，单次三千元以上的开通时间会视情况而定，不再另行通知。）</p>
          <p style="margin-bottom: 10px; text-indent: 2em;">2.用户使用万知网产品及/或活动服务时，应保证所提交的信息的合法性。因用户提供的信息引起的任何法律责任，包括但不限于因违法违规引起的处罚、第三方诉讼纠纷等，用户自行承担全部责任。万知网有权随时终止本协议。</p>
          <p style="margin-bottom: 10px; text-indent: 2em;">3.对于用户通过万知网创建的活动，用户有权使用万知网进行信息编辑、管理及推广。用户知悉并同意，活动一经发布，任何第三人均有权访问其活动。</p>
          <p style="margin-bottom: 20px; text-indent: 2em;">5.用户保证对其提供的或其活动内的图片、文章、音视频及链接等有合法使用权。用户同时保证所上传到万知上的图片、文章、音视频及链接等所导向的第三方网站的所有内容符合法律法规及国家政策的规定，不侵犯任何第三方合法权益。否则万知网有权但无义务下线该活动并终止本协议，且用户应赔偿万知网由此遭受的所有损失。</p>

          <h4 style="margin: 20px 0 10px; font-size: 16px; font-weight: bold;">四、争议解决</h4>
          <p style="margin-bottom: 20px; text-indent: 2em;">本协议的订立、执行和争议的解决均应适用中华人民共和国法律。如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决，协商不成的双方同意在甲方所在地南京市秦淮区人民法院解决。</p>

          <p style="text-align: right; margin-top: 30px; padding-right: 20px;">2025年11月8日</p>
        </div>
      `
    }
  }
}
</script>

<style lang="less" scoped>
:deep(.protocol-dialog) {
  .el-dialog__body {
    padding: 20px;
  }

  .protocol-content {
    height: 500px;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 15px 20px;
    padding-right: 12px;
    line-height: 1.8;
    color: #333;
    background-color: #fafafa;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    font-size: 14px;

    // 自定义滚动条样式
    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 4px;

      &:hover {
        background: #a8a8a8;
      }
    }

    // 富文本内容样式
    :deep(.protocol-text) {
      h3 {
        text-align: center;
        margin-bottom: 20px;
        font-size: 18px;
        font-weight: bold;
        color: #303133;
      }

      h4 {
        margin: 20px 0 10px;
        font-size: 16px;
        font-weight: bold;
        color: #303133;
      }

      p {
        margin-bottom: 12px;
        font-size: 14px;
        color: #606266;
        line-height: 1.8;
        text-align: justify;

        &:last-child {
          margin-bottom: 0;
        }

        strong {
          color: #303133;
          font-weight: 600;
        }
      }

      // 段落首行缩进
      p[style*="text-indent"] {
        text-indent: 2em;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/ProtocolDialog.vue